import { React, useState } from 'react';
// import { returnReceipt, setReceiptPrintCopy } from '../../actions/checks';
import classes from './NavReceiptPostpone.module.css';
import {
  Button,
  Modal,
  Table,
  Accordion,
  InputGroup,
  FormControl,
  Container,
  Row,
  Col,
  Form,
  Stack
} from 'react-bootstrap';
import PutReceiptIcon from '../../../../../images/put.svg';
import Loader from '../../../../../images/loader.gif';
// import SearchIcon from '../../../../images/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useReceiptPostpone } from './hooks/useReceiptPostpone';
import { formatDate, formatMoney, formatWeight } from '../../../../../helpers/dataFormatter';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import DatePickerSelect from '../../../../ui/DatePickerSelect';

const NavReceiptPostpone = (props) => {
  // const dispatch = useDispatch();
  const {
    delay,
    postponeReceipt,
    modalShow,
    showLoader,
    setModalShow,
  } = useReceiptPostpone();

  const onCancel = () => {
    setModalShow(false);
  }

  const onConfirm = () => {
    postponeReceipt();
  }

  //
  return (
    <div>
      <Button
        className={`me-md-2 ${classes.button}`}
        size='sm'
        onClick={(e) => {
          e.target.parentElement.focus();
          e.target.parentElement.blur();
          setModalShow(true)
        }}
      >
        <img className={classes.nav_icon} src={PutReceiptIcon} alt='checklist' /> <div className={classes.icon_text}>Відкласти чек</div>
      </Button>
      {modalShow && (
        <Modal  {...props}
          show={modalShow}
          centered
        >
          <Modal.Body>
            Відкласти поточний чек?
            {showLoader === true && (
              <img
                className='position-absolute top-50 start-50 translate-middle'
                src={Loader}
                style={{ width: '100px' }}
                alt=''
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={showLoader} variant='success' onClick={onConfirm}>
              Так
            </Button>
            <Button variant='outline-secondary' onClick={onCancel}>
              Ні
            </Button>
          </Modal.Footer>
        </Modal>
      )
      }
    </div >
  );
};

export default NavReceiptPostpone;
